import { Injectable } from "@angular/core";
import { createAuthClient } from "better-auth/client";
import { anonymousClient } from "better-auth/client/plugins";
import { environment } from "./environment";

/**
 * Better Auth client service wrapper
 * Initializes and exposes the Better Auth client for frontend authentication
 * with bearer token support and anonymous authentication configured.
 *
 * The Better Auth client with bearer plugin automatically:
 * - Stores bearer tokens in localStorage (key: 'better-auth.session_token')
 * - Injects tokens in Authorization headers automatically
 * - Supports anonymous sign-in via the anonymous plugin
 */
@Injectable({ providedIn: "root" })
export class AuthClientService {
	readonly client = createAuthClient({
		baseURL: environment.serverUrl,
		plugins: [anonymousClient()],
		fetchOptions: {
			credentials: "include",
		},
	});
}
